import React from "react";
import MultilineTextWithCopy from "./MultilineTextWithCopy";

/**
 * Value shape expected by {@link MultilineCellWithCopy}.
 */
export interface MultilineCellWithCopyValue {
    /** Primary line of text. */
    primaryText: string;
    /** Secondary line of text. */
    secondaryText?: string;
    /** Value copied when the copy control is used. */
    copyValue?: string;
}

interface MultilineCellWithCopyProps {
    value: MultilineCellWithCopyValue;
}

/**
 * Two-line table cell using {@link MultilineTextWithCopy}, with no left border.
 *
 * @param props - Cell value with primary/secondary text and optional copy value
 * @returns Two-line cell content
 */
const MultilineCellWithCopy: React.FC<MultilineCellWithCopyProps> = ({
    value,
}) => {
    const primaryText = value?.primaryText ?? "";
    const secondaryText = value?.secondaryText ?? "";
    const copyValue = value?.copyValue ?? "";

    return (
        <div className="table-cell-multiline-text h-full w-full py-[0.375rem]">
            <MultilineTextWithCopy
                primaryText={primaryText}
                secondaryText={secondaryText}
                shouldTruncate
                shouldTruncateSecondary
                copyIconSize={0}
                copyValue={copyValue}
            />
        </div>
    );
};

export default MultilineCellWithCopy;
